import { render, staticRenderFns } from "./PropertyCalendarSidebarContigentItem.vue?vue&type=template&id=5077b40f&scoped=true&"
import script from "./PropertyCalendarSidebarContigentItem.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarSidebarContigentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077b40f",
  null
  
)

export default component.exports